// extracted by mini-css-extract-plugin
export var pillWrapper = "_yr-0";
export var showOverflow = "_yr-1";